// This can be called quite often during the build, so we use caching.

const monthAgoCache: Record<number, number> = [];
export function getMonthAgoTimestamp(monthsAgo: number): number {
  if (!monthAgoCache[monthsAgo]) {
    const date = new Date();
    date.setMonth(date.getMonth() - monthsAgo);
    monthAgoCache[monthsAgo] = Math.floor(date.getTime() / 1000);
  }
  return monthAgoCache[monthsAgo];
}

const daysAgoCache: Record<number, number> = [];
export function getDaysAgoTimestamp(daysAgo: number): number {
  if (!daysAgoCache[daysAgo]) {
    const date = new Date();
    date.setDate(date.getDate() - daysAgo);
    daysAgoCache[daysAgo] = Math.floor(date.getTime() / 1000);
  }
  return daysAgoCache[daysAgo];
}
